"use client";

import { useTranslations } from "next-intl";
import Image from "next/image";
import { type ReactElement, useState } from "react";

import {
  type Kundenstimme,
  type KundenstimmePoster,
  kundenstimmeEmbedSrc,
} from "./kundenstimmen-data";

/**
 * Rendered poster width: 58 % column of the 1240px section on desktop
 * (hero.css .mkhero-stimme-video), full content width below 900px.
 */
const POSTER_SIZES =
  "(min-width: 1240px) 660px, (min-width: 900px) 55vw, 100vw";

/** Clip frame: optional poster + play until click, then the embed (autoplay). */
export function KundenstimmeClip({
  item,
}: {
  readonly item: Kundenstimme;
}): ReactElement {
  const t = useTranslations("marketing.kundenstimmenSection");
  const [playing, setPlaying] = useState(false);
  const poster: KundenstimmePoster | undefined = item.poster;

  if (playing || poster === undefined) {
    return (
      <div className="mkhero-stimme-frame">
        <iframe
          src={kundenstimmeEmbedSrc(item.clipId, {
            autoplay: playing && poster !== undefined,
          })}
          title={item.videoTitle}
          loading="lazy"
          allow="autoplay; clipboard-write; fullscreen"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className="mkhero-stimme-frame">
      <button
        type="button"
        className="mkhero-stimme-poster"
        onClick={() => {
          setPlaying(true);
        }}
      >
        <Image
          src={poster.src}
          alt={poster.alt}
          fill
          sizes={POSTER_SIZES}
          placeholder="blur"
          blurDataURL={poster.blurDataURL}
        />
        <span className="mkhero-stimme-play" aria-hidden="true">
          <svg width="30" height="34" viewBox="0 0 30 34" fill="none">
            <path d="M28 17 4 31.5V2.5L28 17Z" fill="#0B0F19" />
          </svg>
        </span>
        <span className="mkhero-stimme-poster-label">
          {t("videoAbspielen")}
        </span>
      </button>
    </div>
  );
}
